module.exports = __webpack_public_path__ + "img/20201104.1afda798.png";